var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGitlabClean(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1000,
    height: 963,
    viewBox: "0 0 1000 963",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e24329",
    d: "M500 963L655 383H345z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc6d26",
    d: "M500 963L345 383H76z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fca326",
    d: "M76 383L24 543c-9 28 1 59 25 76L500 963 76 383z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#e24329",
    d: "M76 383h269L243 57c-7-21-37-21-44 0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc6d26",
    d: "M500 963l155-580h269z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fca326",
    d: "M924 383l52 160c9 28-1 59-25 76L500 963l424-580z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#e24329",
    d: "M924 383H655l102-326c7-21 37-21 44 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitlabClean);
export default __webpack_public_path__ + "static/media/gitlab-clean.df95dd155460f57a04d84e3ebe0a4e6f.svg";
export { ForwardRef as ReactComponent };